import styles from "./PagerDutyActivity.module.css";

/* PagerDuty timestamps render in the VIEWER'S browser locale + local timezone.
   The team strongly prefers local/browser-locale times over a fixed ET zone, so
   we defer entirely to Intl (locale `undefined` = the browser's locale; no
   explicit timeZone = the browser's local zone). No timezone label is shown —
   the value is already in the viewer's own zone, so the suffix is just noise. */
const DATE_TIME_OPTS = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  // Force 12-hour AM/PM regardless of the locale's default hour cycle (the team
  // prefers AM/PM over 24-hour/"military" time); locale still drives everything else.
  hour12: true,
};
const TIME_OPTS = {
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
};

/**
 * Format an ISO/RFC3339 timestamp to a full date+time in the browser locale.
 * Returns "Unknown" for null/invalid values so the UI never leaks "Invalid Date".
 */
export function formatTimestamp(ts) {
  if (!ts) return "Unknown";
  const d = new Date(ts);
  if (isNaN(d.getTime())) return "Unknown";
  return d.toLocaleString(undefined, DATE_TIME_OPTS);
}

/**
 * Format an ISO/RFC3339 timestamp to a short time only, in the browser locale.
 * Used for nested rows in escalation groups where space is tight.
 * Returns "Unknown" for null/invalid values.
 */
export function formatShortTimestamp(ts) {
  if (!ts) return "Unknown";
  const d = new Date(ts);
  if (isNaN(d.getTime())) return "Unknown";
  return d.toLocaleTimeString(undefined, TIME_OPTS);
}

/**
 * Map a responder status string to a CSS module class name and display label.
 * Statuses: notified | responded | escalated | declined
 */
export function responderStatusProps(status) {
  switch ((status || "").toLowerCase()) {
    case "responded":
      return { cls: styles.statusResponded, label: "Responded" };
    case "escalated":
      return { cls: styles.statusEscalated, label: "Escalated" };
    case "declined":
      return { cls: styles.statusDeclined, label: "Declined" };
    case "notified":
    default:
      return { cls: styles.statusNotified, label: "Notified" };
  }
}
